import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Restaurant } from 'src/services/classes/models/restaurant';
import { RestaurantService } from 'src/services/data/restaurant/restaurant.service';
import { Order, Meal } from 'src/services/classes/models/order-item';
import { Logger } from 'src/services/core/logger/logger.service';
import { NotificationsService } from 'src/services/classes/notifications/notifications.service';
import { CartService } from 'src/services/data/cart/cart.service';
import { DishDetailsComponent } from 'src/app/shared/dish-details/dish-details.component';

const log = new Logger('Order-Items');
@Component({
  selector: 'app-order-items',
  templateUrl: './order-items.component.html',
  styleUrls: ['./order-items.component.scss'],
})
export class OrderItemsComponent implements OnInit, OnChanges {
  @Input() dishes: Order<Meal>;
  @Input() isSuccessPage: boolean;
  @Input() inExpansionPanel = false;
  @Input() specialInstructions: string;
  @Output() refreshCart = new EventEmitter<string>();
  cartDish: Order<Meal>;
  constructor(
    private restaurantService: RestaurantService,
    private router: Router,
    private notifyService: NotificationsService,
    private cartService: CartService,
    private bottomSheet: MatBottomSheet
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      log.debug('changes: ', changes);
      log.debug('dish-input: ', this.dishes);
    }, 1500);
  }

  /**
   * The idea here is to add the dish index to the URL as a query param
   * and check on the dishes component if the URL contains a dishIndex in the params
   * before adding to the cart, if it does, we will be calling another cartService method to add the meal
   * and not the usual addDishToCart or we call a modified addDishToCart
   */

  addMealToDish(dishIndex: string) {
    const restaurantInfo: Restaurant =
      this.restaurantService.fetchRestaurantInformation();
    const branchId = restaurantInfo.restaurantId;
    this.router.navigate(['/', branchId, 'dishes'], {
      queryParams: { dishIndex, fromOrders: '1' },
    });
  }

  handleMealAction(
    mealActionObject: any,
    dishIndex: string,
    mealIndex: number
  ) {
    log.debug(
      'meal-action: ',
      mealActionObject,
      'dishIndex: ',
      dishIndex,
      'mealIndex: ',
      mealIndex
    );
    const action = mealActionObject.action;
    switch (action) {
      case 'delete':
        this.handleDeleteAction(dishIndex, mealIndex);
        break;
      case 'edit':
        this.handleEditAction(mealActionObject, dishIndex, mealIndex);
    }
  }

  handleDeleteAction(dishIndex: string, mealIndex: number) {
    const cart = this.cartService.getCartItems();
    const mealArray = cart.get(dishIndex);

    if (mealArray.length > 1) {
      this.cartService.removeMealFromDishInCart(dishIndex, mealIndex);
      this.notifyService.publishMessages(
        'Meal deleted from dish',
        'success',
        1
      );
    } else {
      this.cartService.removeDishFromCart(dishIndex);
      this.notifyService.publishMessages(
        'Dish removed from cart',
        'success',
        1
      );
    }

    this.refreshCart.emit('refresh-cart');
  }

  handleEditAction(
    mealActionObject: any,
    dishIndex: string,
    mealIndex: number
  ) {
    /**
     * Considerations:
     *
     * Bring in bottomsheet to this component and handle the edit action
     * Need to take the ID of this meal here and make the request to
     * the endpoint to get its full object
     * Then compare the items so you can check the selected addOns and prefill the
     * previous quantity (or not)
     */
    // this.refreshCart.emit('refresh-cart');
    const bottomSheetRefForUpdate = this.bottomSheet.open(
      DishDetailsComponent,
      {
        data: { ...mealActionObject.meal, source: 'for-update' },
      }
    );

    bottomSheetRefForUpdate.afterDismissed().subscribe((data) => {
      log.debug('On update: ', data);
      if (data !== undefined && typeof data !== 'string') {
        const { quantity, name, price, id, addOns, imageUrl, takeawayPrice } = data;
        this.cartService.updateMealInDishInCart(
          { name, price, id, addOns, imageUrl, takeawayPrice },
          quantity,
          dishIndex,
          mealIndex
        );

        this.refreshCart.emit('refresh-cart');
      }
    });
  }
}
